export default __webpack_public_path__ + "static/media/swiftWriter5.bcbdbf23.png";